import React from 'react';
import { useEffect } from 'react';

import { Link } from 'react-router-dom';
import landingPageImage from '../../../assets/landingPageImage.png';
import watermarkImage from '../../../assets/watermark.png';
import Header from "../../Header";
import Footer from "../../Footer";

export default function GuestLandingPage() {

    useEffect(() => {

        localStorage.setItem('token', "");
        localStorage.setItem('user_type', null);
        localStorage.clear();
        // onLogout();
    
        // navigate('/');
      }, []);


    const pageStyle = {
        height: '100vh', // 100% of the viewport height
        margin: '0',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        //backgroundColor: '#095918',
    };

    return (
        <div>
            <Header />
            <div style={pageStyle}>
                <div className="container mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                        <div className="flex flex-col justify-center p-6">
                            <h1 style={{ fontSize: '36px', fontWeight: 'bold' }} className='text-2xl sm:text-2xl md:text-4xl lg:text-4xl xl:text-4xl text-black font-bold py-2'>
                                Verify Certificates/<br />
                                Statements of Result with GACs
                            </h1>
                            <p style={{ fontSize: '16px' }} className='py-2'>
                                Powerful tool to Verify Certificates across the TVET<br />
                                sector of Nigeria
                            </p>
                            
                        </div>
                        <div className="flex justify-center p-6 ">
                            <img
                                src={landingPageImage}
                                alt="Landing Page"
                                style={{ width: '80%', height: 'auto' }}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-6">
                        <div className="flex justify-center l p-6" style={{ flex: '2' }}>
                            <Link className='' to='/guest-registration'><button className="rounded-button" style={{}}>Get Started</button></Link>
                        </div>
                    </div>
                    <img
                        src={watermarkImage}
                        alt="Landing Page"
                        className='absolute bottom-0 left-0'
                        style={{ zIndex: -1 }}
                    />
                    <Footer />
                </div>
            </div>
        </div>
    );
}
